module.exports = __webpack_public_path__ + "media/application/images/placeholder-a49e87ab7075dfe41af2e426ece58244.png";